import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../../common/input';
import CurrencyInput from '../../../common/currencyInput';
import Modal from '../../../common/Modal';

const AddGiftCard = ({
  on,
  off,
  isOn,
  handleSubmit,
  pristine,
  valid,
  submitting,
}) => (
  <div>
    <button
      type="button"
      className="c-btn c-btn--medium u-width-120 u-ml"
      onClick={on}
    >
      Add Card
    </button>
    <Modal title="Add gift card" close={off} display-if={isOn}>
      <form onSubmit={handleSubmit} className="u-ph++ u-pv+">
        <div className="layout">
          <div className="layout__item u-1/2-large-and-up">
            <label className="c-label-new u-block" htmlFor="code">Code</label>
            <Input className="c-input c-input--white" id="code" name="code" placeholder="Enter gift card number" />
          </div>
          <div className="layout__item u-1/2-large-and-up">
            <label className="c-label-new u-block" htmlFor="initialBalance">Amount</label>
            <CurrencyInput
              className="c-input c-input--white"
              id="initialBalance"
              name="initialBalance"
              type="text"
              placeholder="Enter amount"
            />
          </div>
        </div>
        <div className="u-text-center u-mt+">
          <button
            type="submit"
            className="c-btn c-btn--medium"
            disabled={submitting || pristine || !valid}
          >
            Add card
          </button>
        </div>
      </form>
    </Modal>
  </div>
);
AddGiftCard.propTypes = {
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  isOn: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default AddGiftCard;
